import { BellOffIcon, BellRingIcon } from 'lucide-react';

import { DropdownMenuItem } from '@/components/ui/dropdown-menu';

import { SETTINGS_COPY } from '../copy';
import { usePreferences } from '../hooks/usePreferences';

/**
 * Mute or unmute the current workspace, from its own menu (spec 142 US4).
 * Reads the preferences only while the menu is open.
 */
export function WorkspaceMuteItem({
  workspaceId,
  name,
  open,
}: {
  workspaceId: string;
  name: string;
  /** Whether the menu holding this is open; nothing is read until it is. */
  open: boolean;
}) {
  const prefs = usePreferences(open);
  const muted =
    prefs.preferences?.mutes.some((m) => m.workspace.id === workspaceId) ??
    false;
  const Icon = muted ? BellRingIcon : BellOffIcon;
  return (
    <DropdownMenuItem
      disabled={prefs.isPending || prefs.saving}
      onClick={() => {
        prefs.setMuted({ workspaceId, muted: !muted });
      }}
    >
      <Icon aria-hidden="true" className="size-4 shrink-0" strokeWidth={1.5} />
      {muted ? SETTINGS_COPY.unmute(name) : SETTINGS_COPY.mute(name)}
    </DropdownMenuItem>
  );
}
